import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { toast } from 'react-toastify';
import styles from './scanner.module.scss';

function QrScanner({
  onScan,
  width,
  height,
}: {
  onScan: (s:string | null) => void,
  width: number,
  height: number,
}) {
  const scannerRef = useRef(null);
  const html5QrCodeRef = useRef<any>(null);
  const [scanning, setScanning] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const startScan = async () => {
    try {
      const devices = await Html5Qrcode.getCameras();
      if (!devices || devices.length === 0) {
        toast.error('Aucune caméra détecté');
        throw new Error('Aucune caméra détectée');
      }

      html5QrCodeRef.current = new Html5Qrcode('reader');

      const config = {
        fps: 10,
        qrbox: { width: width - 50, height: height - 50 },
        aspectRatio: 1.0,
        showTorchButtonIfSupported: true,
        showZoomSliderIfSupported: true,
        defaultZoomValueIfSupported: 2,
      };

      await html5QrCodeRef.current.start(
        { facingMode: 'environment' },
        config,
        (decodedText:string) => {
          if (decodedText) {
            onScan(decodedText);
          }
        },
        () => {
          // erreurs fréquentes ignorées
        },
      );
      onScan(null);
      setScanning(true);
    } catch (err) {
      console.error('Erreur caméra', err);
      setError(`📷 Autorisation caméra refusée ou indisponible.${JSON.stringify(err)}`);
    }
  };

  // const stopScan = async () => {
  //   if (html5QrCodeRef.current && scanning) {
  //     try {
  //       await html5QrCodeRef.current.stop();
  //       html5QrCodeRef.current.clear();
  //       setScanning(false);
  //     } catch (err) {
  //       console.error('Erreur lors de l\'arrêt de la caméra:', err);
  //     }
  //   }
  // };

  useEffect(() => () => {
    // On s'assure que la caméra est bien arrêtée au démontage
    if (html5QrCodeRef.current) {
      html5QrCodeRef.current.stop()
        .then(() => {
          html5QrCodeRef.current.clear();
          setScanning(false);
        })
        .catch((err:any) => {
          console.error('Erreur lors de l\'arrêt de la caméra:', err);
        });
    }
  }, []);

  return (
    <>
    <div className={styles.scanner}>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div id="reader" ref={scannerRef} style={{
        width,
        height,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }} />
      {!scanning && (
        <button onClick={startScan}>Démarrer le scan</button>
      )}
      {/* // ) : (
      //   <button className={styles.stop} onClick={stopScan}>Arrêter le scan</button>
      // )} */}
    </div>
    </>
  );
}

export default QrScanner;
//
